// context/ProgrammeContext.js
import { createEntityContext } from "./createEntityContext";

export const {
  EntityContext: ProgrammeContext,
  EntityProvider: ProgrammeProvider,
} = createEntityContext("programmes", "/api/programmes");
